<template>
  <div class="flex-column">{{$t('third.text')}}</div>
</template>

<script>
export default {
  name: "Third",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
